import {
  IconAuditorFilled,
  IconAuditorOutline,
  IconJanitorFilled,
  IconJanitorOutline,
} from '@bbl-digital/snorre'
import {
  IconBoardwork,
  IconDashboard,
  IconEconomy,
  IconCommunication,
  IconHousingAssociation,
  IconHousingCooperative,
  IconSustainability,
} from '@bbl-digital/snorre-v2'
import { MenuNameEnum } from 'shared/models/Menu'
import { cn } from '../cn'

const getIconValues = (active: boolean) =>
  cn(
    'text-surface-portalen-aside-icon h-2 w-2',
    active && 'text-surface-portalen-aside-icon-active'
  )
const iconValues = { color: 'white', size: '16px' }

const getMenuIcon = (id: string, active: boolean) => {
  switch (id) {
    case MenuNameEnum.dashboard:
      return <IconDashboard className={getIconValues(active)} />

    case MenuNameEnum.economy:
      return <IconEconomy className={getIconValues(active)} />

    case MenuNameEnum.communication:
      return <IconCommunication className={getIconValues(active)} />

    case MenuNameEnum.boardwork:
      return <IconBoardwork className={getIconValues(active)} />

    case MenuNameEnum.housingcoop:
    case MenuNameEnum.housingcoopDk:
      return <IconHousingAssociation className={getIconValues(active)} />

    case MenuNameEnum.housebuildingcoop:
      return <IconHousingCooperative className={getIconValues(active)} />

    case MenuNameEnum.sustainability:
      return <IconSustainability className={getIconValues(active)} />

    case MenuNameEnum.janitor:
      return active ? (
        <IconJanitorFilled {...iconValues} />
      ) : (
        <IconJanitorOutline {...iconValues} />
      )

    case MenuNameEnum.auditor:
      return active ? (
        <IconAuditorFilled {...iconValues} />
      ) : (
        <IconAuditorOutline {...iconValues} />
      )

    default:
      return null
  }
}

export { getMenuIcon }
